import {
  faHeadphones,
  faMicrophone,
  faMusic,
  faKeyboard,
  faGuitar,
  faVolumeUp,
  faDrum,
  faRecordVinyl,
  faBolt
} from '@fortawesome/free-solid-svg-icons';

export const categories = [
  {
    id: 'estudioGrabacion',
    name: 'Estudio & Grabación',
    icon: faHeadphones,
    subcategories: [
      { id: 'interfacesDeAudio', name: 'Interfaces de Audio' },
      { id: 'monitores', name: 'Monitores de Estudio' },
      { id: 'controladores', name: 'Controladores MIDI' },
      { id: 'auriculares', name: 'Auriculares' },
      { id: 'acustica', name: 'Acústica y Tratamiento' }
    ]
  },
  {
    id: 'microfonos',
    name: 'Micrófonos',
    icon: faMicrophone,
    subcategories: [
      { id: 'condensador', name: 'Micrófonos de Condensador' },
      { id: 'dinamicos', name: 'Micrófonos Dinámicos' },
      { id: 'ribbon', name: 'Micrófonos Ribbon' },
      { id: 'usb', name: 'Micrófonos USB' },
      { id: 'inalambricos', name: 'Sistemas Inalámbricos' }
    ]
  },
  {
    id: 'instrumentos',
    name: 'Instrumentos',
    icon: faGuitar,
    subcategories: [
      { id: 'guitarras', name: 'Guitarras' },
      { id: 'bajos', name: 'Bajos' },
      { id: 'teclados', name: 'Teclados y Pianos' },
      { id: 'baterias', name: 'Baterías y Percusión' },
      { id: 'viento', name: 'Instrumentos de Viento' }
    ]
  },
  // {
  //   id: 'software',
  //   name: 'Software',
  //   icon: faMusic,
  //   subcategories: [
  //     { id: 'daws', name: 'DAWs' },
  //     { id: 'plugins', name: 'Plugins' },
  //     { id: 'virtual', name: 'Instrumentos Virtuales' },
  //     { id: 'efectos', name: 'Efectos' },
  //     { id: 'samples', name: 'Samples y Loops' }
  //   ]
  // },
  {
    id: 'djEquipo',
    name: 'DJ & Producción',
    icon: faRecordVinyl,
    subcategories: [
      { id: 'controladorasDj', name: 'Controladoras DJ' },
      { id: 'tornamesas', name: 'Tornamesas' },
      { id: 'mixers', name: 'Mixers' },
      { id: 'cdj', name: 'Reproductores CDJ' },
      { id: 'accesoriosDj', name: 'Accesorios DJ' }
    ]
  },
  {
    id: 'sonidoEnVivo',
    name: 'Sonido en Vivo',
    icon: faVolumeUp,
    subcategories: [
      { id: 'paAltavoces', name: 'Sistemas PA y Altavoces' },
      { id: 'mezcladores', name: 'Mezcladores en Vivo' },
      { id: 'procesadores', name: 'Procesadores de Señal' },
      { id: 'amplificadores', name: 'Amplificadores' },
      { id: 'monitoresEscenario', name: 'Monitores de Escenario' }
    ]
  },
  {
    id: 'accesorios',
    name: 'Accesorios',
    icon: faKeyboard,
    subcategories: [
      { id: 'cables', name: 'Cables y Conectores' },
      { id: 'soportes', name: 'Soportes y Stands' },
      { id: 'fundas', name: 'Fundas y Cases' },
      { id: 'atriles', name: 'Atriles' },
      { id: 'adaptadores', name: 'Adaptadores' }
    ]
  },
  {
    id: 'percusion',
    name: 'Percusión',
    icon: faDrum,
    subcategories: [
      { id: 'bateriasAcusticas', name: 'Baterías Acústicas' },
      { id: 'bateriasElectronicas', name: 'Baterías Electrónicas' },
      { id: 'percusionLatin', name: 'Percusión Latina' },
      { id: 'platillos', name: 'Platillos' },
      { id: 'accesoriosPercusion', name: 'Accesorios de Percusión' }
    ]
  },
  {
    id: 'amplificacionEfectos',
    name: 'Amplificación & Efectos',
    icon: faBolt, // ⚡️ o el ícono que prefieras de FontAwesome
    subcategories: [
      { id: 'cabezotesGuitarra', name: 'Cabezotes de Guitarra' },
      { id: 'combosGuitarra', name: 'Combos de Guitarra' },
      { id: 'cabezotesBajo', name: 'Cabezotes de Bajo' },
      { id: 'combosBajo', name: 'Combos de Bajo' },
      { id: 'pedalesGuitarra', name: 'Pedales y Efectos de Guitarra' },
      { id: 'pedalesBajo', name: 'Pedales y Efectos de Bajo' }
    ]
  }
]; 